import { Box, getThemeColor, getThemeSpacing } from '@fairfashion/design-system'
import { styled } from 'styled-components'

export const MapWrapper = styled(Box)`
  z-index: 9;
  overflow: hidden;
  border-radius: 16px;
  width: 100%;
  height: 100%;
  border: 1px solid ${({ theme }) => getThemeColor('grey_5', theme)};
`

export const MapSwitch = styled(Box)`
  background-color: ${({ theme }) => `${getThemeColor('white', theme)}AA`};
  padding: ${({ theme }) => getThemeSpacing(1, theme)};
  padding-left: 0;
  align-items: center;
  border-radius: ${({ theme }) => theme.border_radius.input};
  box-shadow: ${({ theme }) => theme.box_shadow.card};
  backdrop-filter: blur(4px);
  position: absolute;
  bottom: 12px;
  right: 12px;
  z-index: 800;
`

export const MapButtons = styled(Box)`
  position: absolute;
  right: 12px;
  top: 12px;
  z-index: 800;
  cursor: pointer;
  align-items: stretch;
  width: 100%;
  justify-content: flex-end;
  gap: ${({ theme }) => getThemeSpacing(1, theme)};
`

export const MapButton = styled(Box)`
  backdrop-filter: blur(4px);
  min-width: 30px;
  align-items: center;
  background-color: ${({ theme }) => `${getThemeColor('white', theme)}AA`};
  padding: ${({ theme }) => getThemeSpacing(1, theme)};
  border-radius: ${({ theme }) => theme.border_radius.input};
  box-shadow: ${({ theme }) => theme.box_shadow.card};
`
